import { Course } from '@/types';
import g1 from '@content/courses/git/modules/01-what-is-git.json';
import g2 from '@content/courses/git/modules/02-git-setup.json';
import g3 from '@content/courses/git/modules/03-staging-area.json';
import g4 from '@content/courses/git/modules/04-first-commit.json';
import g5 from '@content/courses/git/modules/05-branching.json';
import g6 from '@content/courses/git/modules/06-merging.json';
import g7 from '@content/courses/git/modules/07-github.json';
import g8 from '@content/courses/git/modules/08-git-workflow.json';

import h1 from '@content/courses/http/modules/what-is-http.json';
import h2 from '@content/courses/http/modules/request-response-anatomy.json';
import h3 from '@content/courses/http/modules/http-methods.json';
import h4 from '@content/courses/http/modules/url-anatomy.json';
import h5 from '@content/courses/http/modules/status-codes.json';
import h6 from '@content/courses/http/modules/http-debugging.json';
import h7 from '@content/courses/http/modules/https-security.json';
import h8 from '@content/courses/http/modules/http-boss-level.json';

import t1 from '@content/courses/terminal/modules/01-what-is-terminal.json';
import t2 from '@content/courses/terminal/modules/02-basic-navigation.json';
import t3 from '@content/courses/terminal/modules/03-file-manipulation.json';
import t4 from '@content/courses/terminal/modules/04-reading-files.json';
import t5 from '@content/courses/terminal/modules/05-permissions.json';
import t6 from '@content/courses/terminal/modules/06-pipes-redirection.json';
import t7 from '@content/courses/terminal/modules/07-searching-filtering.json';
import t8 from '@content/courses/terminal/modules/08-environment-variables.json';
import t9 from '@content/courses/terminal/modules/09-boss-level-scripting.json';

import nb1 from '@content/courses/networking-basics/modules/01-what-is-a-network.json';
import nb2 from '@content/courses/networking-basics/modules/02-ip-addresses.json';
import nb3 from '@content/courses/networking-basics/modules/03-how-packets-work.json';
import nb4 from '@content/courses/networking-basics/modules/04-osi-model.json';
import nb5 from '@content/courses/networking-basics/modules/05-tcp-vs-udp.json';
import nb6 from '@content/courses/networking-basics/modules/06-ports-and-protocols.json';
import nb7 from '@content/courses/networking-basics/modules/07-how-internet-routes.json';
import nb8 from '@content/courses/networking-basics/modules/08-boss-network-debugging.json';

import dns1 from '@content/courses/dns/modules/01-what-is-dns.json';
import dns2 from '@content/courses/dns/modules/02-domain-names.json';
import dns3 from '@content/courses/dns/modules/03-dns-record-types.json';
import dns4 from '@content/courses/dns/modules/04-dns-resolution.json';
import dns5 from '@content/courses/dns/modules/05-ttl-and-caching.json';
import dns6 from '@content/courses/dns/modules/06-dns-in-practice.json';
import dns7 from '@content/courses/dns/modules/07-dns-security.json';
import dns8 from '@content/courses/dns/modules/08-boss-dns-debugging.json';

import br1 from '@content/courses/browsers/modules/01-what-happens-when-you-hit-enter.json';
import br2 from '@content/courses/browsers/modules/02-how-browsers-render-html.json';
import br3 from '@content/courses/browsers/modules/03-javascript-in-the-browser.json';
import br4 from '@content/courses/browsers/modules/04-critical-rendering-path.json';
import br5 from '@content/courses/browsers/modules/05-browser-storage.json';
import br6 from '@content/courses/browsers/modules/06-browser-security-model.json';
import br7 from '@content/courses/browsers/modules/07-devtools.json';
import br8 from '@content/courses/browsers/modules/08-boss-browser-debugging.json';

import ts1 from '@content/courses/typescript/modules/01-why-typescript-exists.json';
import ts2 from '@content/courses/typescript/modules/02-basic-types-and-inference.json';
import ts3 from '@content/courses/typescript/modules/03-functions-unions-and-narrowing.json';
import ts4 from '@content/courses/typescript/modules/04-interfaces-and-type-aliases.json';
import ts5 from '@content/courses/typescript/modules/05-objects-classes-and-implements.json';
import ts6 from '@content/courses/typescript/modules/06-generics-and-reusable-utilities.json';
import ts7 from '@content/courses/typescript/modules/07-tsconfig-modules-and-third-party-types.json';
import ts8 from '@content/courses/typescript/modules/08-boss-migrate-a-javascript-module.json';

import hc1 from '@content/courses/html-css/modules/01-what-html-and-css-do.json';
import hc2 from '@content/courses/html-css/modules/02-semantic-html-and-media.json';
import hc3 from '@content/courses/html-css/modules/03-selectors-cascade-and-specificity.json';
import hc4 from '@content/courses/html-css/modules/04-box-model-and-display.json';
import hc5 from '@content/courses/html-css/modules/05-flexbox-and-grid-layout.json';
import hc6 from '@content/courses/html-css/modules/06-forms-states-and-accessibility.json';
import hc7 from '@content/courses/html-css/modules/07-responsive-design-and-debugging.json';
import hc8 from '@content/courses/html-css/modules/08-boss-build-a-landing-page.json';

import js1 from '@content/courses/javascript/modules/01-what-javascript-is.json';
import js2 from '@content/courses/javascript/modules/02-operators-and-conditions.json';
import js3 from '@content/courses/javascript/modules/03-loops-and-iteration.json';
import js4 from '@content/courses/javascript/modules/04-functions-and-scope.json';
import js5 from '@content/courses/javascript/modules/05-arrays-and-objects.json';
import js6 from '@content/courses/javascript/modules/06-dom-scripting.json';
import js7 from '@content/courses/javascript/modules/07-classes-and-oop.json';
import js8 from '@content/courses/javascript/modules/08-js-gotchas.json';
import js9 from '@content/courses/javascript/modules/09-async-and-fetch.json';
import js10 from '@content/courses/javascript/modules/10-javascript-in-the-wild.json';

export const COURSES: Record<string, Course> = {
    terminal: {
        id: 'terminal',
        title: 'Terminal — Your Command Center',
        description: 'Learn the keyboard shortcuts, navigation moves, and superpowers that make the terminal your primary controller.',
        icon: '⌨️',
        xp_reward: 1010,
        total_modules: 9,
        badge_on_complete: 'terminal-master',
        is_published: true,
        is_available: false,
        modules: [t1, t2, t3, t4, t5, t6, t7, t8, t9] as any
    },
    'networking-basics': {
        id: 'networking-basics',
        title: 'Networking — How Computers Find Each Other',
        description: 'Understand packets, ports, and protocols so every future course makes sense.',
        icon: '🗺️',
        xp_reward: 860,
        total_modules: 8,
        badge_on_complete: 'networking-basics-master',
        is_published: true,
        is_available: true,
        modules: [nb1, nb2, nb3, nb4, nb5, nb6, nb7, nb8] as any
    },
    dns: {
        id: 'dns',
        title: 'DNS — The Internet’s Phone Book',
        description: 'Decode domains, records, and resolvers so you can debug any “why is this site down?” fire.',
        icon: '📒',
        xp_reward: 840,
        total_modules: 8,
        badge_on_complete: 'dns-master',
        is_published: true,
        is_available: true,
        modules: [dns1, dns2, dns3, dns4, dns5, dns6, dns7, dns8] as any
    },
    browsers: {
        id: 'browsers',
        title: 'Browsers — What Happens When You Hit Enter',
        description: 'Trace the entire rendering pipeline, storage APIs, and devtools that power every page.',
        icon: '🖥️',
        xp_reward: 870,
        total_modules: 8,
        badge_on_complete: 'browsers-master',
        is_published: true,
        is_available: true,
        modules: [br1, br2, br3, br4, br5, br6, br7, br8] as any
    },
    typescript: {
        id: 'typescript',
        title: 'TypeScript — JavaScript Grown Up',
        description: "Keep JavaScript's speed, add guardrails, and catch mistakes before they hit production.",
        icon: '🔷',
        xp_reward: 900,
        total_modules: 8,
        badge_on_complete: 'type-guardian',
        is_published: true,
        is_available: false,
        modules: [ts1, ts2, ts3, ts4, ts5, ts6, ts7, ts8] as any
    },
    'html-css': {
        id: 'html-css',
        title: 'HTML & CSS — Building the Web',
        description: 'Structure the page, style the surface, and make layouts survive every screen size.',
        icon: '🏗️',
        xp_reward: 900,
        total_modules: 8,
        badge_on_complete: 'markup-master',
        is_published: true,
        is_available: true,
        modules: [hc1, hc2, hc3, hc4, hc5, hc6, hc7, hc8] as any
    },
    javascript: {
        id: 'javascript',
        title: 'JavaScript — Making Pages Interactive',
        description: 'Write logic that responds to clicks, builds forms, and talks to servers. Turn your static pages into living applications.',
        icon: '⚙️',
        xp_reward: 1290,
        total_modules: 10,
        badge_on_complete: 'js-navigator',
        is_published: true,
        is_available: true,
        modules: [js1, js2, js3, js4, js5, js6, js7, js8, js9, js10] as any
    },
    git: {
        id: 'git',
        title: 'GIT — The Save System',
        description: 'Master the industry-standard version control system and never lose your work again.',
        icon: '💾',
        xp_reward: 850,
        total_modules: 8,
        badge_on_complete: 'git-master',
        is_published: true,
        is_available: true,
        modules: [
            g1, g2, g3, g4, g5, g6, g7, g8
        ] as any
    },
    http: {
        id: 'http',
        title: 'HTTP — How the Internet Talks',
        description: 'Every line of code you write eventually sends a message. Learn to speak it.',
        icon: '🌐',
        xp_reward: 900,
        total_modules: 8,
        badge_on_complete: 'http-master',
        is_published: true,
        is_available: true,
        modules: [
            h1, h2, h3, h4, h5, h6, h7, h8
        ] as any
    }
};

export const getCourseById = (id: string) => COURSES[id];
